import React, { Component } from 'react';
import Img from 'gatsby-image';
import {shevy} from '../components/StyledComponents'
import _ from 'lodash'
import { 
  PostContainer, 
  PostHero, 
  PostDate, 
  TagContainer, 
  TagItem, 
  Category 
} from '../components/StyledComponents'

export class PostSingle extends Component {
  componentDidMount() {
    $('.gatsby-resp-image-link').attr('data-featherlight', 'image');
  }

  render() {
    const { data } = this.props;
    return (
      <div>

        { data.markdownRemark.fields.thumbnail && 
          <PostHero>
            <Img
              fadeIn={true}
              resolutions={data.markdownRemark.fields.thumbnail.childImageSharp.resolutions} 
            />
          </PostHero>
        }

        <PostContainer offsetTop={data.markdownRemark.fields.thumbnail ? true : false}>
          {data.markdownRemark.frontmatter.date &&
            <div>
              <PostDate>{data.markdownRemark.frontmatter.date}</PostDate>&nbsp;<Category>{data.markdownRemark.frontmatter.category}</Category>
            </div>
          }

          <h1>{data.markdownRemark.frontmatter.title}</h1>

          <div 
            dangerouslySetInnerHTML={{
              __html: data.markdownRemark.html
            }} 
          />
          
          { data.markdownRemark.fields.hero && 
            <Img
              fadeIn={true}
              resolutions={data.markdownRemark.fields.hero.childImageSharp.resolutions} 
            />
          }

          {data.markdownRemark.frontmatter.tags &&
            <TagContainer>
              {data.markdownRemark.frontmatter.tags.map(tag =>
                <TagItem key={tag} to={`/tag/${_.kebabCase(tag)}/`}>{tag}</TagItem>
              )}
            </TagContainer>
          }

        </PostContainer>
      </div>
    );
  }
}

export default PostSingle;

export const query = graphql`
  query PostSingleQuery($slug: String!) {
    markdownRemark(
      fields: {
        slug: {
          eq: $slug
        }
      }
    ) {
      html
      fields {
        hero: hero {
          childImageSharp {
            resolutions(width: 800) {
              src
              srcSet
              width
              height
            }
          }
        }
        thumbnail: hero {
          childImageSharp {
            resolutions(
              width: 1600,
              duotone: { 
                highlight: "#74c0fc",
                shadow: "#339af0"
              }, 
              toFormat: PNG
            ) {
              src
              srcSet
              width
              height
            }
          }
        }
      }
      frontmatter {
        title
        date(formatString: "MMM DD, YYYY")
        category
        tags
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/PostSingle.js